import React, { Component } from "react";
import "./style.less";
interface iProps {
  logo: string;
  name: string;
  schoolName: string;
  mode?: string
}
export default class Logo extends Component<iProps> {
  get title() {
    let { schoolName, name } = this.props;
    return name ? `${name} | ${schoolName}` : "";
  }
  render() {
    let { logo, schoolName, name, mode = 'dark' } = this.props;
    return (
      <div
        style={{
          height: 48,
          marginRight: 80,
          display: "flex",
          alignItems: "center",
        }}
      >
        <img
          style={{
            width:32,
            height: 32,
            borderRadius: "100%",
          }}
          src={logo}
          alt=""
        />
        <div
          style={{
            display:"flex",
            width:144,
            height:48,
            paddingLeft:10,
            fontSize: 12,
            fontWeight: 400,
            alignItems:"center",
            lineHeight: "17px",
            color: "#fff",
          }}
        >
          <div>
            <div style={{color: mode === 'dark' ? '#fff' : '#333'}} className="logo_schoolName">{schoolName}</div>
            {
              schoolName  && schoolName.length && (schoolName.length <= 11)
              && <div style={{color: mode === 'dark' ? 'rgba(255, 255, 255, .5)' : '#666'}}  className="logo_name">{name}</div>
            }
          </div>
          {/* <div>
            <div className="logo_schoolName">北京师范大学</div>
            <div className="logo_name">昌平中学</div>
          </div> */}
          {/* {this.title} */}
        </div>
      </div>
    );
  }
}
